import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import ErrorScreen from '~/components/ErrorScreen/ErrorScreen';
import SibLanding from '~/components/SibLanding/SibLanding';
import { startNewApplication } from '~/services/SdkService';
import type { SdkError } from '~/types/interaction';
import { isSIBHost } from '~/utils/constants';
import { getErrorMessage } from '~/utils/utilities';

const Apply = () => {
  const { referrerId } = useParams();
  const sibHost = isSIBHost();

  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  //start the guest flow application journey for the user
  const startApplication = async () => {
    if (!referrerId) {
      setError(getErrorMessage({ message: 'Invalid referrer' } as SdkError));
      return;
    }
    const [ok, result] = await startNewApplication(referrerId);
    if (!ok) {
      setError(getErrorMessage(result as SdkError));
    }
  };

  // On the SIB landing, the SDK is triggered on CTA click instead of on mount.
  const handleGetLoan = async () => {
    setError(null);
    setLoading(true);
    await startApplication();
    setLoading(false);
  };

  // Non-SIB referrers keep the existing auto-trigger behaviour on mount.
  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    if (!sibHost) {
      startApplication();
    }
  }, [referrerId]);

  // SIB host: render the LAMF landing page; SDK fires only on CTA click.
  // On error the button re-enables for retry; no error UI is shown.
  if (sibHost) {
    return <SibLanding onGetLoan={handleGetLoan} loading={loading} />;
  }

  return !loading && error ? (
    <ErrorScreen
      message="Resume application to start where you left off and get instant loan"
      title="Complete your application"
      onButtonClick={async () => {
        setError(null);
        setLoading(true);
        await startApplication();
        setLoading(false);
      }}
      ctaText="Resume application"
    />
  ) : (
    <div />
  );
};

export default Apply;
